import { Option } from '@sapphire/result';
import { randomString } from '@ps/utils';

import { Category } from '../../models/category.model';
import { QuestionFormModel } from '../../models/question-detail.model';
import { PRIVACY_POLICY_QUALIFICATION_ID } from '../../constants/localization-options.constants';
import { QuestionPayloadDto } from '../dtos/question-detail.dto';
import { LocalizationPayloadMapper } from './localization-payload.mapper';

export class QuestionPayloadMapper {
  private readonly _localizationPayloadMapper = new LocalizationPayloadMapper();

  public toPayload(
    model: QuestionFormModel,
    allCategories: Category[],
    questionId?: number,
  ): QuestionPayloadDto {
    const resolvedCategories = allCategories
      .filter((category) => model.categoryIds.includes(category.id))
      .map((category) => ({ id: category.id, label: category.label }));

    const isPrivacyPolicyQuestion = Option.from(questionId).mapOr(
      false,
      (id) => String(id) === PRIVACY_POLICY_QUALIFICATION_ID,
    );

    return {
      attribute_id: model.attributeId || randomString(5),
      cmp: model.companyIds,
      is_hidden: model.isHidden,
      desc: model.desc,
      category: resolvedCategories,
      type: model.type,
      class: model.class,
      ...(model.tags.length > 0 && { tags: model.tags.join(',') }),
      stem1: model.stem1,
      stem2: model.stem2,
      buyer_text: model.buyerText,
      create_survey_question_order: Option.from(model.createSurveyOrder).mapOr(
        '',
        String,
      ),
      answer_order: Option.from(model.answerOrder).unwrapOr(1),
      localizations: model.localizations.map((localization) =>
        this._localizationPayloadMapper.toPayload(
          localization,
          isPrivacyPolicyQuestion,
        ),
      ),
      recency: model.recency,
    };
  }
}
